<template>
  <!-- border border-yellow-400 sm:border-red-500 md:border-blue-200 lg:border-green-500-->
  <div class="relative">
    <NuxtImg v-if="article.image" 
             :src="toImgixPath(article.image)"
             loading="lazy"
             provider="imgix" 
             format="webp"
             :width="width"
             :height="height"
             :loading="lazyload"
             :fit="fit" 
             :sizes="sizes" 
             :modifiers="modifiers" 
             :alt="altText" 
             class="w-full articleImage" />
    <!-- Overlay med gradient från svart till transparent -->
    <div v-if="overlay" class="absolute top-0 right-0 left-0 bottom-[80%] bg-linear-to-t from-transparent to-black/70"></div>
    <div class="absolute bottom-0 left-0 w-full md:w-auto">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const {toImgixPath} = useImageUtils();

// Props
const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  modifiers: {
    type: Object,
    default: () => ({
      auto: 'format,compress',
      fit: 'crop',
      crop: 'faces,edges'
    })
  },
  fit:{
    type: String,
    default: 'crop'
  },
  sizes: {
    type: String,
    default: 'sm:100vw md:1024px lg:1280px xl:1535 2xl:2500'
  },
  width: {
    type: Number,
    default: 265
  },
  height: {
    type: Number,
    default: 225
  },
  lazy: {
    type: Boolean,
    default: false
  },
  overlay: {
    type: Boolean,
    default: false
  }

});

const altText = computed(() => {
  
  return props.article.altText || props.article.title || 'Article image';
});


const lazyload = computed(() => {
  return props.lazy ? 'lazy' : 'eager';
});

// Sizes for responsive images

</script>